import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/helpers";
import { PageHeader, EmptyState } from "@/components/Common";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const RESOURCES = ["", "pos", "products", "inventory", "gold_rates", "discounts", "schemes", "customers", "users", "roles", "branches"];

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [resource, setResource] = useState("");

  const load = async () => {
    const q = resource ? `?resource=${resource}` : "";
    setRows((await api.get(`/audit${q}`)).data);
  };
  useEffect(() => { load(); }, [resource]);

  return (
    <div className="p-6 lg:p-8 fade-in">
      <PageHeader title="Audit Log" subtitle="Immutable trail of critical actions with actor, values & IP.">
        <Select value={resource || "all"} onValueChange={(v) => setResource(v === "all" ? "" : v)}>
          <SelectTrigger className="w-[180px] bg-white border-[#E6E2D6]" data-testid="audit-filter"><SelectValue placeholder="All modules" /></SelectTrigger>
          <SelectContent className="bg-white">
            <SelectItem value="all">All modules</SelectItem>
            {RESOURCES.filter(Boolean).map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
          </SelectContent>
        </Select>
      </PageHeader>

      <Card className="bg-white border-[#E6E2D6] shadow-sm">
        {rows.length === 0 ? <EmptyState /> : (
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Time</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead>
                  <TableHead>Module</TableHead><TableHead>Description</TableHead><TableHead>IP</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {rows.map((a) => (
                  <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                    <TableCell className="text-xs text-[#8A8A8A] whitespace-nowrap">{fmtDate(a.created_at)}</TableCell>
                    <TableCell className="text-sm">{a.user_name}</TableCell>
                    <TableCell><Badge className="bg-[#F2EBE1] text-[#8A6D2F] border-0 capitalize">{a.action}</Badge></TableCell>
                    <TableCell className="text-sm">{a.resource}</TableCell>
                    <TableCell className="text-sm text-[#4A4A4A]">{a.description}</TableCell>
                    <TableCell className="text-xs text-[#8A8A8A]">{a.ip_address}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
